import React from 'react';
import { Scale, Heart, Zap, Compass } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const WhyThisCourse = () => {
  const { t } = useLanguage();

  const benefits = [
    { id: 1, icon: Scale, title: t('restoreBalance'), description: t('restoreBalanceDesc') },
    { id: 2, icon: Heart, title: t('transformRelationships'), description: t('transformRelationshipsDesc') },
    { id: 3, icon: Zap, title: t('unlockCreativity'), description: t('unlockCreativityDesc') },
    { id: 4, icon: Compass, title: t('spiritualPath'), description: t('spiritualPathDesc') }
  ];

  const experiences = [
    t('experience1'),
    t('experience2'),
    t('experience3'),
    t('experience4'),
    t('experience5'),
    t('experience6')
  ];

  return (
    <section id="about" className="py-16 md:py-24 bg-[#1a1f2e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <div className="text-center mb-6">
          <h2 className="text-3xl md:text-4xl font-bold text-white">{t('whyThisCourse')}</h2>
        </div>

        {/* Description */}
        <p className="text-gray-400 text-center text-lg max-w-3xl mx-auto mb-16">
          {t('whyDesc')}
        </p>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {benefits.map((benefit) => {
            const IconComponent = benefit.icon;
            return (
              <div
                key={benefit.id}
                className="bg-[#232836] rounded-xl p-8 hover:bg-[#2a3142] transition-all duration-300 border border-transparent hover:border-gray-700"
              >
                <div className="w-14 h-14 bg-blue-500 rounded-lg flex items-center justify-center mb-6">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{benefit.title}</h3>
                <p className="text-gray-400 leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>

        {/* What You Will Experience */}
        <div className="bg-gradient-to-r from-[#2a3142] to-[#1f2535] rounded-2xl p-8 md:p-12">
          <h3 className="text-2xl md:text-3xl font-bold text-white text-center mb-10">
            {t('whatYouWillExperience')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-6">
            {experiences.map((experience, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[#d4a33a] rounded-full mt-2 flex-shrink-0" />
                <p className="text-gray-300">{experience}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyThisCourse;
